import PropTypes from 'prop-types';

import { cn } from '#/lib/utils';
import SnProductMappingStatusBadge from '#/modules/crmMgmt/aftersales/snProductMapping/components/SnProductMappingStatusBadge';
import { formatCustomerAssignment } from '#/modules/crmMgmt/aftersales/snProductMapping/helper/productCode';
import { formatDateTimeOrDash } from '#/utils/date';

function displayDash(value) {
  if (value === null || value === undefined || value === '') {
    return '—';
  }
  return value;
}

const InfoField = ({ label, value }) => (
  <div>
    <p className="text-xs text-gray-500">{label}</p>
    <p className="mt-0.5 text-sm font-medium wrap-break-word text-gray-900">{value}</p>
  </div>
);

InfoField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node.isRequired,
};

const SnProductMappingDetailSection = ({
  detail,
  customer,
  customerLoading,
  actions = null,
}) => {
  const customerLabel = customerLoading
    ? '載入中…'
    : formatCustomerAssignment(detail?.customerId, customer);

  return (
    <div className="receipt-card-elevate">
      <div className="receipt-card-surface p-5">
        <div className="flex flex-wrap items-start justify-between gap-3">
          <div className="flex min-w-0 flex-1 flex-wrap items-center gap-2">
            <h1 className="text-2xl font-bold text-gray-900">
              {displayDash(detail?.productCode)}
            </h1>
            {detail?.status ? (
              <SnProductMappingStatusBadge status={detail.status} />
            ) : null}
          </div>
          {actions ? (
            <div className="flex shrink-0 flex-wrap items-center justify-end gap-2">
              {actions}
            </div>
          ) : null}
        </div>
        <div
          className={cn(
            'mt-4 grid grid-cols-1 gap-x-4 gap-y-3 border-t border-slate-200 pt-4',
            'sm:grid-cols-2 md:grid-cols-4',
          )}
        >
          <InfoField label="產品名稱" value={displayDash(detail?.productName)} />
          <InfoField label="客戶" value={customerLabel} />
          <InfoField
            label="建立"
            value={formatDateTimeOrDash(detail?.record?.createdAt)}
          />
          <InfoField
            label="修改"
            value={formatDateTimeOrDash(detail?.record?.updatedAt)}
          />
          <div className="sm:col-span-2 md:col-span-4">
            <InfoField label="備註" value={displayDash(detail?.remark)} />
          </div>
        </div>
      </div>
    </div>
  );
};

SnProductMappingDetailSection.propTypes = {
  detail: PropTypes.object,
  customer: PropTypes.object,
  customerLoading: PropTypes.bool,
  actions: PropTypes.node,
};

export default SnProductMappingDetailSection;
